export default {
  methods: {
    /*
     * Reference:
     * Ex: #5 @ https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
     */
    cookieExists(cookieName) {
      return document.cookie
        .split(';')
        .filter((c) => c.trim().startsWith(`${cookieName}=`))
        .length > 0;
    },
    getCookieValue(cookieName) {
      const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
      return (match) ? match[2] : null;
    },
  },
};
